import { IconRefresh, ButtonPseudo, ButtonSize } from '@ui/src';
import { CreateFeeBlockTypes } from '../types';

import cn from '../styles.module.css';

const CreateFeeBlock = ({
  children,
  title,
  isModified,
  withButton,
  buttonDisabled,
  onClick,
}: CreateFeeBlockTypes) => (
  <div className={cn.createFeeBlock}>
    {title && (
      <div className={cn.createFeeBlockTitle}>
        <div className={cn.createFeeBlockTitleLeft}>
          {title}
          {isModified && <div className={cn.modified}>Modified</div>}
        </div>
        {withButton && (
          <ButtonPseudo
            icon={<IconRefresh />}
            text="Restore defaults"
            disabled={buttonDisabled}
            size={ButtonSize.SMALL}
            className={cn.restoreButton}
            onClick={onClick}
            bold
          />
        )}
      </div>
    )}
    {children}
  </div>
);

export default CreateFeeBlock;
